import React from 'react';
const CustomTitleTemplate = props => {
  return (
    <h2
      className="text-on-secondary-container text-lg font-semibold pt-4"
      {...props}
    >
      {props.title}
    </h2>
  );
};

export default CustomTitleTemplate;
